import React, { Component } from 'react';
import { Card } from '../StyledComponents/Card';
import Loader from './Loader';

const dummyElementsArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

let loadingCards = dummyElementsArr.map((card, index) => {
  return (
    <Card key={index}>
      <Loader />
    </Card>
  );
});

class MainListLoader extends Component {
  render() {
    return <div>{loadingCards}</div>;
  }
}

export default MainListLoader;
